module.exports = __webpack_public_path__ + "static/media/footer_green.8cda48b0.png";